/**
 * Reorders Size variant picker options into a logical order:
 * - Text sizes: Small, Medium, Large, XL, XXL, XXXL, etc.
 * - Numeric sizes: ascending (e.g. 8, 10, 12)
 */
(function () {
  var SIZE_TEXT_ORDER = [
    'xxs', 'xs', 'extra small', 'small', 's',
    'm', 'medium',
    'l', 'large',
    'xl', '2xl', 'xxl', '3xl', 'xxxl', '4xl', 'xxxxl', '5xl', 'xxxxxl'
  ];

  function getSizeSortKey(value) {
    var text = (value || '').toString().trim().toLowerCase();
    var num = parseFloat(text.replace(/[^0-9.-]/g, ''), 10);
    if (!isNaN(num) && text !== '') {
      return { type: 'number', value: num, text: text };
    }
    var index = SIZE_TEXT_ORDER.indexOf(text);
    if (index !== -1) {
      return { type: 'text', value: index, text: text };
    }
    return { type: 'text', value: SIZE_TEXT_ORDER.length, text: text };
  }

  function compareSizes(a, b) {
    var aKey = getSizeSortKey(a);
    var bKey = getSizeSortKey(b);
    if (aKey.type !== bKey.type) {
      return aKey.type === 'number' ? -1 : 1;
    }
    if (aKey.value !== bKey.value) {
      return aKey.value - bKey.value;
    }
    return aKey.text.localeCompare(bKey.text);
  }

  function getOptionLabelText(node) {
    var label = node.querySelector && node.querySelector('.pill__label');
    if (label) return (label.textContent || '').trim();
    return (node.textContent || '').trim();
  }

  function reorderSizeOptionsInPicker(picker) {
    var labelContainers = picker.querySelectorAll('[data-variant-picker-option-labels]');
    var inputContainers = picker.querySelectorAll('[data-variant-picker-option-inputs]');

    labelContainers.forEach(function (labelContainer, optionIndex) {
      var optionName = (labelContainer.getAttribute('option-picker-name') || '').toLowerCase();
      if (optionName !== 'size') return;

      var inputContainer = inputContainers[optionIndex];
      if (!inputContainer) return;

      var pillList = labelContainer.querySelector('.product-variant-picker__pill-list');
      var dropdownBody = labelContainer.querySelector('.variant-picker-dropdown__body');
      var shapeSwatches = labelContainer.querySelector('.product-variant-picker__shape-swatches');
      var imageSwatches = labelContainer.querySelector('.image-swatches');

      var labelElements = null;
      var getValueFromNode = null;

      if (pillList) {
        labelElements = [].slice.call(pillList.querySelectorAll('label'));
        getValueFromNode = function (node) {
          return getOptionLabelText(node);
        };
      } else if (dropdownBody) {
        labelElements = [].slice.call(dropdownBody.querySelectorAll('label'));
        getValueFromNode = function (node) {
          var span = node.querySelector('span');
          return span ? (span.textContent || '').trim() : (node.textContent || '').trim();
        };
      } else if (shapeSwatches) {
        labelElements = [].slice.call(shapeSwatches.querySelectorAll('label[data-color-swatches-picker-label]'));
        getValueFromNode = function (node) {
          return (node.getAttribute('data-value') || '').trim();
        };
      } else if (imageSwatches) {
        labelElements = [].slice.call(imageSwatches.querySelectorAll('label'));
        getValueFromNode = function (node) {
          var forId = node.getAttribute('for');
          if (!forId) return '';
          var input = document.getElementById(forId);
          return input ? (input.value || '').trim() : '';
        };
      }

      if (!labelElements || labelElements.length === 0) return;

      var values = labelElements.map(getValueFromNode);
      var order = values.slice().sort(compareSizes);
      var indices = order.map(function (v) {
        return values.indexOf(v);
      });

      var sortedLabels = indices.map(function (i) {
        return labelElements[i];
      });

      sortedLabels.forEach(function (label) {
        if (pillList) pillList.appendChild(label);
        if (dropdownBody) dropdownBody.appendChild(label);
        if (shapeSwatches) shapeSwatches.appendChild(label);
        if (imageSwatches) imageSwatches.appendChild(label);
      });

      var inputWrappers = [].slice.call(inputContainer.querySelectorAll(':scope > div'));
      if (inputWrappers.length !== sortedLabels.length) return;

      var inputOrder = indices.map(function (i) {
        return inputWrappers[i];
      });
      inputOrder.forEach(function (wrapper) {
        inputContainer.appendChild(wrapper);
      });
    });
  }

  function run() {
    var pickers = document.querySelectorAll('variant-picker');
    pickers.forEach(reorderSizeOptionsInPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    var shouldRun = mutations.some(function (m) {
      return [].some.call(m.addedNodes || [], function (node) {
        return node.nodeType === 1 && (
          node.classList && node.classList.contains('product') ||
          node.querySelector && node.querySelector('variant-picker')
        );
      });
    });
    if (shouldRun) {
      setTimeout(run, 0);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
